import { constants } from './expressionFinder.constant'
import { expressionFinderSelectors } from './expressionFinder.selector'

import { useEvent, useState } from '@/core'

type State = {
	[key: string]: string
}

export const ExpressionFinderComponent = (() => {
	const { state, setState } = useState<State>()

	const handleMouseEnter = (target: HTMLElement) => {
		const action = useEvent(target, 'mouseenter')
		action.register((e) => {
			e.preventDefault()
		})
	}

	const handleMouseLeave = (target: HTMLElement) => {
		const action = useEvent(target, 'mouseleave')
		action.register((e) => {
			e.preventDefault()
		})
	}

	const initHandlers = () => {
		const handlers = expressionFinderSelectors.getHandlers()
		for (let i = 0, { length } = handlers; i < length; i++) {
			const handler = handlers[i]
			handleMouseEnter(handler)
			handleMouseLeave(handler)
		}
	}

	const find = (id: string, expression: string) => {
		const target = expressionFinderSelectors.getTarget(id)
		if (!target) {
			return
		}

		const { innerHTML } = target
		if (!expression.length) {
			target.innerHTML = state[id]
			setState({ [id]: '' })
		}

		setState({ [id]: innerHTML })
		target.innerHTML = innerHTML.replaceAll(
			expression,
			`<span style="background-color: ${target.getAttribute(
				constants.selector.color,
			)};" class="text-white bg-primary-400">${expression}</span>`,
		)
	}

	const init = () => {
		initHandlers()
	}

	return {
		init,
		find,
	}
})()
